/**
 * Pure balance computation for bank, credit card, and brokerage accounts.
 *
 * Bank / Brokerage: balance = openingBalance + credits − debits
 * Credit card: balance = openingBalance + charges − payments
 *   (charges = debits, payments = credits; negative result = amount owed)
 *
 * Returns { computed_balance, total_inflows, total_outflows, has_opening_balance }
 */
export function computeAccountBalance({
  transactions,
  openingBalance,
  openingBalanceDate,
  reportType,
  asOfDate,
}) {
  const ob = typeof openingBalance === 'number' ? openingBalance : 0;
  const hasOB = typeof openingBalance === 'number';

  let inflows = 0;
  let outflows = 0;

  for (const tx of transactions) {
    if (asOfDate && tx.date > asOfDate) continue;
    if (hasOB && openingBalanceDate && tx.date <= openingBalanceDate) continue;

    const amt = Math.abs(tx.convertedTotal ?? tx.total ?? tx.amount ?? 0);
    if (tx.transactionDirection === 'credit') {
      inflows += amt;
    } else {
      outflows += amt;
    }
  }

  let computed_balance;
  if (reportType === 'credit_card') {
    // Positive outflows = charges; positive inflows = payments; negative result = owed
    computed_balance = ob + outflows - inflows;
  } else {
    // bank, brokerage
    computed_balance = ob + inflows - outflows;
  }

  return {
    computed_balance,
    total_inflows: inflows,
    total_outflows: outflows,
    has_opening_balance: hasOB,
  };
}
